/**
 * Emprise monde d'une entité du plan — partagée par le scan de l'analyse
 * (`analysis-scan.ts`) et la lecture des entités rattachées aux observations
 * (`observation.ts`).
 */

import type { DrawingModuleType } from "../DrawingSingleton";
import type { DrawingModule } from "../types/DrawingWeb";
import type { WorldBbox } from "@/utils/plan-analysis/types";
import { deleteObj } from "../core/delete";

/**
 * Emprise monde d'une entité déjà ouverte en lecture, null si invalide.
 * Alloue/libère ses wrappers ODA à chaque appel.
 */
export function readEntityBbox(
  module: DrawingModuleType,
  entity: DrawingModule.OdDbEntity,
): WorldBbox | null {
  const ext = new module.OdGeExtents3d();
  try {
    entity.getGeomExtents(ext);
    if (!ext.isValidExtents()) return null;
    const mn = ext.minPoint();
    const mx = ext.maxPoint();
    const bbox: WorldBbox = {
      minX: mn.x,
      minY: mn.y,
      maxX: mx.x,
      maxY: mx.y,
    };
    deleteObj(mn);
    deleteObj(mx);
    return bbox;
  } catch {
    return null;
  } finally {
    deleteObj(ext);
  }
}
